'use strict';

document.addEventListener( 'alpine:init', () => {
	var checkboxes = document.querySelectorAll( '.accordion-item input[type="checkbox"]' );

	checkboxes.forEach( function( checkbox ) {
		checkbox.addEventListener( 'change', function() {
			var content = this.nextElementSibling.nextElementSibling;
			content.style.maxHeight = this.checked ? content.scrollHeight + 'px' : 0;
		});
	});
});